
export function notificationInterfaceFn() {
    console.log('Mock Notification Service');
	window.MockNotificationService = (function () {
		const mockNotifications = [];
		let nextId = 1;
		const nowUTC = () => new Date().toISOString();
		const farFuture = null;
        const ancient = '0001-01-01T00:00:00Z';
		function createId() {
			return (nextId++).toString();
		}
		function find(id) {
            return mockNotifications.find(n => n.id == id && !n.attributes.deleted);
		}
		return {
			get: function (orgPersonId, sourceSystem) {				
				const updatedNotificationItems = [];
				const finalResponse = Promise.resolve({
                    data: mockNotifications.filter(n => {
                        if (n.attributes.recipient.RecipientId === orgPersonId &&
                        !n.attributes.deleted) {
							updatedNotificationItems.push({
								title: n.attributes.subject,
								content: n.attributes.content,
								unread: !n.attributes.acknowledgeAtUtc,
								timestamp: n.attributes.createdUtc,
                                id: n.id
							});
						}
                    })
				});
                return updatedNotificationItems.length > 0 ? updatedNotificationItems : [];
			},
			create: function (notification) {
				const id = createId();
				const created = {
					id: id,
                    type: 'messages',
					attributes: {
						acknowledgeAtUtc: farFuture,
						...notification,
						expireAfterUtc: ancient,
						createdUtc: nowUTC(),
						changedUtc: nowUTC(),
						deletedUtc: farFuture,
						deleted: false,
						ownerId: id,
						ownerVersionNumber: 0,
                        objectName: 'Message',
                        objectTypeName: 'Message',
                        contextName: 'Message',
						contextId: id,
                        authorizationContext: 'Message',
						protectedObjectIsContextObject: true,
                        actualObjectTypeName: 'Messagev1',
					},
					links: {
                        self: `https://mock-notification.local/api/notificationinbox/${id}`
                    }
				};
				mockNotifications.push(created);
                console.log(`Creating final payload: ${JSON.stringify(created)}`);
				return Promise.resolve(created);
			},
			markAsRead: function (id) {
				const notif = find(id);
				if (notif) {
					notif.attributes.acknowledgeAtUtc = nowUTC();
					notif.attributes.changedUtc = nowUTC();
					console.log(`Mock MARK READ: ${id}`);
					return Promise.resolve(notif);
				}
				return Promise.reject(`Notification ${id} not found`);
			},
			markAsUnread: function (id) {
				const notif = find(id);
				if (notif) {
					notif.attributes.acknowledgeAtUtc = farFuture;
					notif.attributes.changedUtc = nowUTC();
					console.log(`Mock MARK UNREAD: ${id}`);
					return Promise.resolve(notif);
				}
				return Promise.reject(`Notification ${id} not found`);
			},
			dismiss: function (id) {
				const notif = find(id);
				if (notif) {
					notif.attributes.deleted = true;
					notif.attributes.deletedUtc = nowUTC();
					notif.attributes.changedUtc = nowUTC();
					console.log(`Mock DISMISS: ${id}`);
					return Promise.resolve({ success: true });
				}
				return Promise.reject(`Notification ${id} not found`);
			},
			unacknowledge: function (id) {
				const notif = find(id);
				if (notif) {
					notif.attributes.acknowledgeAtUtc = farFuture;
					notif.attributes.changedUtc = nowUTC();
					console.log(`Mock UNACKNOWLEDGE: ${id}`);
					return Promise.resolve(notif);
				}
				return Promise.reject(`Notification ${id} not found`);
            }
		};
	})();
}